<template>
  <div>
    <el-row type="flex" justify="end">
      <el-col :span="24">
        <el-button
          class="right"
          type="primary"
          icon="el-icon-plus"
          @click="open"
          >{{ $t("adicionar") }}</el-button
        >
        <el-button
          type="info"
          class="right mr-3"
          icon="el-icon-upload"
          @click="open"
          >{{ $t("importar") }}</el-button
        >
      </el-col>
    </el-row>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";

export default {
  name: "ShippingAddFormPricetable",
  props: ['tableData'],
  data() {
    return {
      dialog: false,
      ruleForm: {
        id: null,
        cep: '',
        address: '',
        name: '',
        city: '',
        neighborhood: '',
        state: '',
        number: '',
        extent: '',
        type: 'main',
      }
    };
  },
  methods: {
    open() {
      this.ruleForm = {
        id: null,
        cep: '',
        address: '',
        name: '',
        city: '',
        neighborhood: '',
        state: '',
        number: '',
        extent: '',
        type: this.isPrincipal ? 'collect' : 'main',
      };
      this.dialog = true;
    },
    edit(row) {
      this.ruleForm = row;
      this.ruleForm.cep = row.zipcode;
      this.dialog = true;
    },
    remove(index) {
      const vm = this;
      const addressData = vm.tableData[index];
      this.$confirm(
        i18n.t("confirmar-eliminacao-endereco", { name: addressData.zipcode }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.$emit("remove", index);
      });
    },
    add() {
      const vm = this;
      if (!vm.ruleForm.name) return this.$message({ type: "error", message: "Nome é obrigatório!" });
      if (!vm.ruleForm.type) return this.$message({ type: "error", message: "Tipo de endereço é obrigatório!" });
      if (!vm.ruleForm.cep) return this.$message({ type: "error", message: "CEP é obrigatório!" });
      if (!vm.ruleForm.address) return this.$message({ type: "error", message: "Endereço é obrigatório!" });
      if (!vm.ruleForm.city) return this.$message({ type: "error", message: "Cidade é obrigatória!" });
      if (!vm.ruleForm.neighborhood) return this.$message({ type: "error", message: "Bairro é obrigatório!" });
      if (!vm.ruleForm.state) return this.$message({ type: "error", message: "Estado é obrigatório!" });
      if (!vm.ruleForm.number) return this.$message({ type: "error", message: "Número é obrigatório!" });

      const zipcodeData = vm.tableData.find(x => x.zipcode === vm.ruleForm.cep);
      if (zipcodeData) return this.$message({ type: "error", message: "CEP já cadastrado para o cliente!" })

      vm.$emit("add", { 
        ...vm.ruleForm,
        zipcode: vm.ruleForm.cep,
      });
      vm.dialog = false;
    },
  }
};
</script>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>